// Sugalarm — where a full-screen overlay mounts (cycle 453.2).
//
// ⚠ "NOTHING COVERS AN ALARM CONTROL" IS A STACKING-CONTEXT RULE, NOT A
// z-index RULE. Every frame root is its own stacking context: the kiosk
// `.kiosk` stage (a `transform: scale()` when scaled) and the phone / web
// frame roots (`isolation: isolate`). Anything painted OUTSIDE that root —
// a portal to `document.body`, a sibling of the frame — is compared with the
// frame as a whole, so it covers every alarm banner inside it whatever its
// own z-index. An overlay that must sit BELOW the alarm banners therefore has
// to mount INSIDE the frame root, at a z-index under the alarm layer's 370.
//
// Each frame root carries `data-overlay-host`; exactly one frame is mounted
// at a time. Off any frame (signed out, the admin console) this returns
// null and the caller falls back to `document.body`.

export const OVERLAY_HOST_ATTR = "data-overlay-host";

export function overlayHost(): HTMLElement | null {
  if (typeof document === "undefined") return null;
  return document.querySelector<HTMLElement>(`[${OVERLAY_HOST_ATTR}]`);
}
